import angular from 'angular';
import FlowInstructionHistoryBridge from './FlowInstructionHistory/FlowInstructionHistoryBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowInstructionHistory', FlowInstructionHistoryBridge);
